export default __webpack_public_path__ + "static/media/abdulmateen.54d8ca24.png";